import styled from 'styled-components';

export const Container = styled.div`
    padding: 20px;  // Reduzido de 30px

    p {
        display: block;
    }

    h2 {
        display: block;
        margin-bottom: 5px;
        color: rgb(0, 107, 219);
    }

    label {
        display: block;
        margin-top: 20px;  // Reduzido de 40px
        margin-bottom: 5px;
    }

    button {
        cursor: pointer;
        width: 120px;
        height: 40px;  // Altura reduzida de 50px
        border-radius: 10px;
        background-color: rgb(0, 107, 219);
        color: whitesmoke;
        border: none;
        margin-top: 10px;  // Reduzido de 20px
    }

    a {
        padding: 0 15px;
        text-decoration: none;
        color: rgb(0, 107, 219);
    }

    .passo {
        margin-bottom: 10px;  // Reduzido de 20px
    }

    input,
    select {
        display: block;
        margin-top: 5px;  // Reduzido de 7px
        box-sizing: border-box;
        width: 100%;
        padding: 10px;  // Reduzido de 20px 10px
        border: 2px solid rgb(0, 107, 219);
        border-radius: 10px;
        font-size: 15px;  // Uniformizado o tamanho da fonte
        outline: 0;
        background-color: rgb(235, 235, 235);
    }

    .error {
        border: 2px solid red;
    }

    .button-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;  // Reduzido de 20px
    }

    .right-button {
        margin-left: auto;
    }

    .ip-container {
        display: flex;
        align-items: center;
    }

    .ip-button {
        cursor: pointer;
        height: 40px;  // Altura mantida
        border-radius: 10px;
        background-color: rgb(0, 107, 219);
        color: whitesmoke;
        border: none;
        padding: 0 10px;  // Espaçamento interno do botão
        white-space: nowrap;  // Impede a quebra de linha no texto
    }
`;
